import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditEmployee from '../../components/employees/FormAddEditEmployee';
import { useParams } from 'react-router-dom';
import { useGetEmployee } from '../../hooks/employees/useGetEmployee';
import LoadingPage from '../../components/global/LoadingPage';

const EditEmployee = () => {
    const { id } = useParams();
    const { employee, isLoading } = useGetEmployee(id);
    if (isLoading) return <LoadingPage />;
    return (<WrapperSection><GlobalBreadcrumbs /><FormAddEditEmployee isEdit currentData={employee?.data} /></WrapperSection>);
};
export default EditEmployee;
